import { Container, Grid, SimpleGrid, Skeleton, rem } from '@mantine/core';
import React from 'react';

const PRIMARY_COL_HEIGHT = rem(300);

function DashBoard() {
    const SECONDARY_COL_HEIGHT = `calc(${PRIMARY_COL_HEIGHT} / 2 - var(--mantine-spacing-md) / 2)`;

    return (
        <Container my="md">
            {/* Agency Admin Panel Dashboard
            <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="md">
                <Skeleton height={PRIMARY_COL_HEIGHT} radius="md" animate={false} />
                <Grid gutter="md">
                    <Grid.Col>
                        <Skeleton height={SECONDARY_COL_HEIGHT} radius="md" animate={false} />
                    </Grid.Col>
                    <Grid.Col span={6}>
                        <Skeleton height={SECONDARY_COL_HEIGHT} radius="md" animate={false} />
                    </Grid.Col>
                    <Grid.Col span={6}>
                        <Skeleton height={SECONDARY_COL_HEIGHT} radius="md" animate={false} />
                    </Grid.Col>
                </Grid>
            </SimpleGrid> */}
            <center>
                <h3>Welcome to FAME.Live for Agencies</h3>
                <h3>For any support, please contact support@famelive.eu</h3>
            </center>
        </Container>
    );
}

export default DashBoard;
